// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AnnouncementNotice_wrapper"};